export default __webpack_public_path__ + "static/samsunngs20-3501960275ea7203491e7183336ec69b.webm";